// extracted by mini-css-extract-plugin
export default {"lineBreak":"lineBreak-jO8Dy","ssoLink":"ssoLink-JhLnL","ssoUnlink":"ssoUnlink-jNcqM","link":"link-tEeYn","text":"text-tu4cQ"};